import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator'; 
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Order } from 'src/app/app.models';
import { AppService } from 'src/app/app.service';
import { PaymentService } from 'src/app/services/payment.service';
import { OrderDetailsDialogComponent } from 'src/app/shared/order-details-dialog/order-details-dialog.component';
import { mespaiements } from './mes-paiements';
import { VerifResponsiveService } from 'src/app/services/verif-responsive.service';

@Component({
  selector: "app-mes-paiements",
  templateUrl: "./mes-paiements.component.html",
  styleUrls: ["./mes-paiements.component.scss"],
})
export class MesPaiementsComponent implements OnInit {
  public userIn: any;
  user: any = [];
  customerList: any;
  resultcat: any;
  paieTot: number;
  lastExpense: number;
  displayedColumns: string[] = [
    "id",
    //"paiement_order_number",
    "montant",
    "location",
    "paiement_means_paie",
    "date",
  ];
  dataSource!: MatTableDataSource<any>;
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort!: MatSort;
  public stores = [
    { id: 1, name: "Store 1" },
    { id: 2, name: "Store 2" },
  ];

  public viewType: string = "list";
  public column: number = 4;
  public p: number = 1;

  currency: string;

  constructor(
    private appService: AppService,
    public paiementService: PaymentService,
    private verifResponsiveService:VerifResponsiveService
  ) {}

  ngOnInit(): void {

    this.currency = this.appService.getCurrency();

    this.dataSource = new MatTableDataSource(mespaiements);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.getCar();

    this.verifResponsiveService.confirmResponsive().subscribe((data) => {
      console.log(data);
      this.viewType = data ? 'grid' : 'list';
    });
  }
  public getCar() {
    const storageAuth = localStorage.getItem("user");
    if (storageAuth) {
      this.userIn = JSON.parse(storageAuth);
    }

    this.paiementService.allpaiment(this.userIn.id).subscribe((data: any) => {
      
      this.resultcat = data;
     
      this.lastExpense = data[0].paiement_montant;

      this.dataSource = new MatTableDataSource<any>(this.resultcat);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;

    });

    this.paiementService.sumPaiement(this.userIn.id).subscribe((data: any) => {
      this.paieTot = data;
      console.log(this.paieTot, data);
    });
  }

  public refresh(){
    this.getCar();
  }
 
  changeViewType(viewType:string)
  {
    this.viewType = viewType;
  }

}
